import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Html from "react-pdf-html";
import {styles } from "../../StylesPdfReport";
import Chart from "./Chart";
import ChartSubsection from "./ChartSubsection";

const stylesheet = {
    html: {
        fontSize: "11pt",
    },
    p: {
        fontFamily: "Rubik",
        fontWeight: 400,
        fontSize: "11pt",
        textTransform: undefined,
    },
    ul: {
        fontFamily: "Rubik",
        fontWeight: 400,
        fontSize: "11pt",
        textTransform: undefined,
    },
    li: {
        fontFamily: "Rubik",
        fontWeight: 400,
        fontSize: "11pt",
        textTransform: undefined,
    },
};

const SubcategorySection = ({ skillsData, type, small= false }: any) => {

    return (
        <>
            <View wrap>
                <Text style={[styles.h1, { marginTop: "11pt" }]}>
                    {skillsData.numbering1}. {skillsData.categoryName}
                </Text>
                <Text style={styles.h2}>
                    {skillsData.numbering1}. {skillsData.numbering2}. {skillsData.subcategoryName}
                </Text>
                <Chart
                    left={skillsData.graphLeft}
                    scoreDescription={skillsData.score_description}
                    bottom={skillsData.graphBottom}
                    testScore={skillsData.score}
                    segmentsImage={skillsData.graphSegmentsImage}
                    type={type}
                />
            </View>
            {skillsData.description && Array.isArray(skillsData.description) ? (
                <>
                    <View>
                        <Text style={styles.h3}>Scor BRIO {skillsData.score}</Text>
                        <View style={styles.subsectionContent}>
                            <Text style={styles.p}>{skillsData.description[0]}</Text>
                            {skillsData.description.map(
                                (description: any, index: any) => (index !== 0 && <Text key={index}>{description}</Text> ),
                            )}
                        </View>
                    </View>
                    <View>
                        <View style={styles.title}>
                            <Text style={{ marginRight: "3pt", marginTop: "20pt" }}>NIVELUL CORESPUNZĂTOR SCORULUI {skillsData.score}:</Text>
                            <View style={{ width: "10px", height: "10px", margin: 0, bottom: "-3pt", position: "relative", marginTop: "20pt"}}>
                                <View style={{ backgroundColor: skillsData.color, width: 10, height: 10 }}></View>
                            </View>
                        </View>
                        <View style={styles.subsectionContent}>
                            {skillsData.scoreDescription.lenght > 0 && skillsData.score_description.map((scoreDescriptions: any, index: any) => (
                                <View key={index}>
                                    {scoreDescriptions.level.toLowerCase() === skillsData.level && (
                                        <Html style={{ fontSize: 9 }} stylesheet={stylesheet}>
                                            {scoreDescriptions.description}
                                        </Html>
                                    )}
                                </View>
                            ))}
                        </View>
                    </View>

                    {skillsData.scoreDescription.map((scoreDescriptions: any, index: any) => (
                        <>
                            {scoreDescriptions.study_time !== null && skillsData.score < 95 && (
                                <Text key={index} style={[styles.h3, { marginTop: "20pt" }]}>
                                    Timp de studiu necesar pentru a ajunge la nivelul următor de dezvoltare a competenței:{" "}
                                    {scoreDescriptions.study_time} ore
                                </Text>
                            )}
                        </>
                    ))}
                </>
            ) : (
                <Html style={{ fontSize: 9 }} stylesheet={stylesheet}>
                    {/*test*/}
                    {skillsData.description}
                </Html>
            )}

            {skillsData.gradeLevels.length > 0 && (
                <>
                    <Text style={styles.h2}>Scala de evaluare - {skillsData.subcategoryName}</Text>
                    {skillsData.gradeLevels.map((gradeLevel: any, index: any) => (
                        <View key={index}>
                            <ChartSubsection gradeLevel={gradeLevel} score={skillsData.score} index={index} type={type} small={small}/>
                        </View>
                    ))}
                </>
            )}

        </>
    );
};

export default SubcategorySection;
